var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.61 3.27373C28.4551 3.13994 28.2666 3.05097 28.0648 3.01638C27.863 2.9818 27.6557 3.00293 27.465 3.07748L2.13251 12.9912C1.77349 13.1308 1.46954 13.3833 1.26642 13.7106C1.06329 14.0379 0.97199 14.4223 1.00625 14.806C1.04052 15.1897 1.1985 15.5519 1.4564 15.838C1.71431 16.1241 2.05819 16.3187 2.43626 16.3925L9.00001 17.6812V25C8.99872 25.3986 9.11719 25.7885 9.34006 26.119C9.56294 26.4495 9.87995 26.7055 10.25 26.8537C10.6195 27.0046 11.0258 27.0408 11.4162 26.9577C11.8065 26.8745 12.1628 26.6759 12.4388 26.3875L15.6038 23.105L20.625 27.5C20.9873 27.8213 21.4545 27.9991 21.9388 28C22.151 27.9998 22.3618 27.9665 22.5638 27.9012C22.8937 27.7965 23.1904 27.6072 23.4245 27.3522C23.6585 27.0971 23.8216 26.7852 23.8975 26.4475L28.9713 4.37498C29.0166 4.17592 29.007 3.96826 28.9434 3.77426C28.8797 3.58026 28.7645 3.40724 28.61 3.27373ZM20.9675 7.77373L9.76876 15.7937L3.56876 14.5775L20.9675 7.77373ZM11 25V19.065L14.0988 21.7825L11 25ZM21.9413 26L11.6063 16.9375L26.4813 6.27623L21.9413 26Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.0abac6fcbba101e6dec25560cd5615ad.svg";
export { ForwardRef as ReactComponent };